module.exports = __webpack_public_path__ + "img/lrb_logo.eeedb1dd.png";